var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "idea-is-safe-wrapper" }, [
    _c("div", { staticClass: "idea-is-safe" }, [
      _c("div", { staticClass: "content-container" }, [
        _c("div", { staticClass: "content d-flex flex-column flex-md-row" }, [
          _vm._m(0),
          _c("div", { staticClass: "every-idea-is-safe" }, [
            _c("p", { staticClass: "title font-outfit-semi-bold" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("pages.pricing.ideaIsSafe.everyIdeaIsSafeWithUs")
                  ) +
                  " "
              ),
            ]),
            _c("p", { staticClass: "description" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "pages.pricing.ideaIsSafe.businessPlansShouldStaySecret"
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "d-flex flex-column list-item-wrapper" },
            [
              _c("idea-is-safe-list-item", {
                attrs: {
                  icon: require("@/assets/img/pricing/idea-is-safe/user-secret.svg"),
                  title: _vm.$t("pages.pricing.ideaIsSafe.personalData"),
                  description: _vm.$t(
                    "pages.pricing.ideaIsSafe.nobodyElseCanHaveAccess"
                  ),
                },
              }),
              _c("idea-is-safe-list-item", {
                attrs: {
                  icon: require("@/assets/img/pricing/idea-is-safe/shield.svg"),
                  title: _vm.$t(
                    "pages.pricing.ideaIsSafe.confidentialityGuaranteed"
                  ),
                },
                scopedSlots: _vm._u([
                  {
                    key: "description",
                    fn: function () {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "pages.pricing.ideaIsSafe.weGuaranteeThatWeWillKeepYouIdeasConfidential"
                              )
                            ) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            staticClass:
                              "cursor-pointer decoration-none terms-of-service",
                            attrs: {
                              href: "https://ideabuddy.com/terms-of-service",
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pages.pricing.ideaIsSafe.termsOfService"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("img", {
        staticClass: "safebox",
        attrs: {
          src: require("@/assets/img/pricing/idea-is-safe/safebox.png"),
          alt: "safebox",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }